module.exports = __webpack_public_path__ + "img/smartlocal1.17225f6c.png";